<script module lang="ts">
    import { CalendarDateTime } from '@internationalized/date';
    import type { Props as InternalProps } from './InternalDateTime.svelte';

    export type { dateToInternal, internalToDate } from './InternalDateTime.svelte';
    export type Props = Omit<InternalProps, 'value' | 'minValue' | 'maxValue'> & {
        value: Date | null;
        minValue?: Date | null;
        maxValue?: Date | null;
        showValidation?: boolean;
        onValueChange?: (value: Date | null) => void;
    };
</script>

<script lang="ts">
    import InternalDateTime from './InternalDateTime.svelte';
    import { Label } from '@/components/ui/label';
    import { getLocalTimeZone } from '@internationalized/date';

    let { value = $bindable(), minValue, maxValue, label, args, showValidation = false, onValueChange, ...props }: Props = $props();

    // Convert string to Date and validate
    if (typeof value === 'string') {
        const date = new Date(value);
        value = !isNaN(date.getTime()) ? date : null;
    }

    let internalValue = $derived(
        value && !isNaN(value.getTime())
            ? new CalendarDateTime(
                  value.getFullYear(),
                  value.getMonth() + 1,
                  value.getDate(),
                  value.getHours(),
                  value.getMinutes(),
                  value.getSeconds(),
              )
            : undefined
    );

    let internalMinValue = $derived(
        minValue && !isNaN(minValue.getTime())
            ? new CalendarDateTime(
                  minValue.getFullYear(),
                  minValue.getMonth() + 1,
                  minValue.getDate(),
                  minValue.getHours(),
                  minValue.getMinutes(),
                  minValue.getSeconds(),
              )
            : undefined
    );

    let internalMaxValue = $derived(
        maxValue && !isNaN(maxValue.getTime())
            ? new CalendarDateTime(
                  maxValue.getFullYear(),
                  maxValue.getMonth() + 1,
                  maxValue.getDate(),
                  maxValue.getHours(),
                  maxValue.getMinutes(),
                  maxValue.getSeconds(),
              )
            : undefined
    );
</script>
<div class="flex-auto">
    <InternalDateTime
        bind:value={
        () => internalValue,
        (v) => {
            if (v) {
                // Convert CalendarDateTime to Date using user's local timezone
                // This ensures times are correctly converted to UTC for server storage
                value = v.toDate(getLocalTimeZone());
            } else {
                value = null;
            }
            // Call onValueChange callback if provided
            if (onValueChange) {
                onValueChange(value);
            }
        }
    }
        minValue={internalMinValue}
        maxValue={internalMaxValue}
        {label}
        {showValidation}
        {...props}
    />
</div>
